// extracted by mini-css-extract-plugin
export default {"questionHeaderContainer":"QuestionHeader_questionHeaderContainer__g78tG","image":"QuestionHeader_image__fId+A"};